import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={17}
            height={18}
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M12.12 1.31L4.15 3.957c-5.356 1.792-5.356 4.714 0 6.497l2.366.786.785 2.366c1.783 5.358 4.713 5.358 6.495 0l2.657-7.963c1.183-3.576-.76-5.527-4.333-4.335zm.282 4.749L9.05 9.43a.655.655 0 01-.468.194.655.655 0 01-.468-.194.666.666 0 010-.936l3.354-3.372a.666.666 0 01.935 0 .666.666 0 010 .936z"
            fill={theme["#0EA59D"]}
        />
        </svg>
    )
}

export default SvgComponent